module.exports = __webpack_public_path__ + "img/hero_splitbullets.b971f1c0.png";